module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 98.6f1fa29e.png";